module.exports = __webpack_public_path__ + "assets/img/One Holland Village.63f38e7d.jpg";